import type { RailwayFareSelection, RailwaySeat, RailwayTicketsData, RailwayTrain } from "../types";

/** 身份不含金额，避免报价变化把同一个方案变成两项。 */
export function fareSelectionId(data: Pick<RailwayTicketsData, "date" | "purpose">, train: RailwayTrain, seat: RailwaySeat, berthName: string | null): string {
  return JSON.stringify([data.date, data.purpose, train.train_no || train.id, train.origin_code, train.destination_code, seat.code, berthName]);
}

/** 只从实际查询结果生成方案；具体铺位不以基础价格代替。 */
export function createFareSelection(data: RailwayTicketsData, train: RailwayTrain, seat: RailwaySeat, berthName: string | null = null): RailwayFareSelection | null {
  const price = berthName === null ? seat.price : seat.berths.find((berth) => berth.name === berthName)?.price;
  if (price == null || !Number.isFinite(price) || price < 0 || (berthName === null && seat.berths.length > 0)) return null;
  return {
    id: fareSelectionId(data, train, seat, berthName), date: data.date, purpose: data.purpose, queriedAt: data.queried_at,
    trainCode: train.train_code, originName: train.origin_name, destinationName: train.destination_name,
    departTime: train.depart_time, arriveTime: train.arrive_time, arrivalDayOffset: train.arrival_day_offset,
    seatName: seat.name, berthName, price,
    availability: seat.availability === "unknown" ? "暂不可用" : `${seat.display}${seat.waitlist === "restricted" ? "（受限）" : seat.availability === "sold_out" && seat.waitlist === "unknown" ? "（候补未确认）" : ""}`,
  };
}

/** 按目标位置移动一项，非法目标与同位拖动保持原顺序。 */
export function moveFareSelection(items: RailwayFareSelection[], activeId: string, targetId: string): RailwayFareSelection[] {
  const from = items.findIndex((item) => item.id === activeId);
  const to = items.findIndex((item) => item.id === targetId);
  if (from < 0 || to < 0 || from === to) return items;
  const next = [...items];
  next.splice(to, 0, ...next.splice(from, 1));
  return next;
}
